var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWalk = function SvgWalk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.688 2.188c0 .687-.563 1.25-1.25 1.25-.688 0-1.25-.563-1.25-1.25 0-.688.562-1.25 1.25-1.25.687 0 1.25.562 1.25 1.25ZM4.375 14.374l1.75-8.813L5 6v2.125H3.75V5.187L7 3.813c.094 0 .172-.015.25-.03.078-.016.156-.032.25-.032.438 0 .813.25 1.063.625l.624 1c.5.875 1.5 1.5 2.688 1.5v1.25a4.577 4.577 0 0 1-3.438-1.563l-.374 1.875 1.312 1.25v4.688h-1.25v-3.75l-1.313-1.25-1.125 5H4.375Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    width: 9,
    height: 15,
    x: 3,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9.688 2.188c0 .687-.563 1.25-1.25 1.25-.688 0-1.25-.563-1.25-1.25 0-.688.562-1.25 1.25-1.25.687 0 1.25.562 1.25 1.25ZM4.375 14.374l1.75-8.813L5 6v2.125H3.75V5.187L7 3.813c.094 0 .172-.015.25-.03.078-.016.156-.032.25-.032.438 0 .813.25 1.063.625l.624 1c.5.875 1.5 1.5 2.688 1.5v1.25a4.577 4.577 0 0 1-3.438-1.563l-.374 1.875 1.312 1.25v4.688h-1.25v-3.75l-1.313-1.25-1.125 5H4.375Z",
    clipRule: "evenodd"
  })))));
};
export default SvgWalk;